import { Component } from '@angular/core';
import { Angular2TokenService } from 'angular2-token';

@Component({
  selector: 'my-app',
  template: `
    <modal></modal>
    <router-outlet></router-outlet>
  `,
})
export class AppComponent {

  constructor(private tokenService: Angular2TokenService) {
    this.tokenService.init({
       apiPath: '/api/v1',
    });
  }

}



// WEBPACK FOOTER //
// /Users/jason/src/matrix/client/src/app/app.component.ts